export const cardList = [
  {
    allMedia: true,
    articles: '1675',
    avatar:
      'https://uc-avatar-cn.heytapimage.com/titans-usercenter-avatar-bucket-cn/default-new.png',
    cover: '',
    createTime: 0,
    followers: '3978',
    followingsCount: 0,
    isFollowed: false,
    mediaAuthority: 0,
    mediaH5Url: '',
    mediaId: '296177',
    mediaNo: 'kAjI49NCoIFNXFdBcdDwhA',
    mediaShareUrl:
      'https://dhfs-test-cpc.wanyol.com/userfiles/cms/media_homepage/index.html?&net=wifi&__source__=oppo&__pf__=mediaPage&isShareH5=1&__publisher_id__=YrF3xY8Wkicrk_NGrq-U3Q&distribution=oppo&f=json&__media_id__=296177',
    name: '天天共读66',
    off: false,
    plusV: false,
    source: 'oppo',
    summary: '以文字的形式，展示一个个全新的画面！',
    type: 0,
    index: 0,
    isAttention: true,
  },
  {
    allMedia: true,
    articles: '1675',
    avatar:
      'http://i1.go2yd.com/image.php?url=http://si1.go2yd.com/get-image/0OCDcPMSAfA&type=webp_300x300&source=oppobrowser',
    cover: '',
    createTime: 0,
    followers: '3978',
    followingsCount: 0,
    isFollowed: false,
    mediaAuthority: 0,
    mediaH5Url: '',
    mediaId: '296177',
    mediaNo: 'YrF3xY8Wkicrk_NGrq-U3Q',
    mediaShareUrl:
      'https://dhfs-test-cpc.wanyol.com/userfiles/cms/media_homepage/index.html?&net=wifi&__source__=oppo&__pf__=mediaPage&isShareH5=1&__publisher_id__=YrF3xY8Wkicrk_NGrq-U3Q&distribution=oppo&f=json&__media_id__=296177',
    name: '天天共读',
    off: false,
    plusV: false,
    source: 'oppo',
    summary: '以文字的形式，展示一个个全新的画面！',
    type: 0,
    index: 1,
    isAttention: true,
  },
  {
    name: '金剪刀',
    summary: '东北烧烤的作者金剪刀简介',
    mediaId: '3333',
    mediaNo: 'w8AZXD-PdD2PQnP4DCWH2A',
    index: 2,
  },
  {
    avatar:
      'http://i1.go2yd.com/image.php?url=http://si1.go2yd.com/get-image/0OCDcPMSAfA&type=webp_300x300&source=oppobrowser',
    name: '哈哈4',
    summary: '哈哈哈4简介',
    isAttention: true,
    mediaId: '44444444',
    mediaNo: '44444444444444',
    index: 3,
    isAttention: false,
  },
  {
    avatar:
      'http://i1.go2yd.com/image.php?url=http://si1.go2yd.com/get-image/0OCDcPMSAfA&type=webp_300x300&source=oppobrowser',
    name: '哈5',
    summary: '哈哈哈5简介',
    mediaId: '555555',
    mediaNo: '55555555555555',
    isAttention: true,
    index: 4,
  },
  // {
  //   avatar: "http://i1.go2yd.com/image.php?url=http://si1.go2yd.com/get-image/0OCDcPMSAfA&type=webp_300x300&source=oppobrowser",
  //   name: '哈哈6',
  //   summary: '哈哈哈6简介',
  //   mediaId: "66666666",
  //   mediaNo: "66666",
  //   isAttention: true,
  //   index: 5
  // },
  // {
  //   avatar: "http://i1.go2yd.com/image.php?url=http://si1.go2yd.com/get-image/0OCDcPMSAfA&type=webp_300x300&source=oppobrowser",
  //   name: '',
  //   summary: '哈哈哈7简介',
  //   mediaId: "77777",
  //   mediaNo: "777777777777",
  //   isAttention: true,
  //   index: 6
  // },
];
